export default __webpack_public_path__ + "static/media/ImgGift04.b582fcfb.jpg";